import { useEffect, useState } from "react";
import { PenLine } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Btn, Field, Input } from "./common";

export function RenameUser({ target, onDone }) {
  const [name, setName] = useState(target.name || "");
  const [apply, setApply] = useState(true);
  const [usage, setUsage] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/admin/users/${target.id}/name-usage`).then((r) => setUsage(r.data.records)).catch(() => setUsage(null)); }, [target.id]);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/admin/users/${target.id}/rename`, { new_name: name, apply_to_records: apply }); toast.success(`Name corrected. ${data.records_updated} record(s) updated.`); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-3" data-testid="rename-user">
      <p className="text-sm text-[#6E6259]">Current name: <b>{target.name}</b>{usage !== null && <> · written on <b data-testid="rename-usage-count">{usage}</b> record(s) and history entries</>}</p>
      <Field label="Corrected full name"><Input data-testid="rename-new-name-input" value={name} onChange={(e) => setName(e.target.value)} /></Field>
      <label className="flex items-center gap-2 text-sm"><input type="checkbox" data-testid="rename-apply-checkbox" checked={apply} onChange={(e) => setApply(e.target.checked)} /> Also correct the name on everything they entered and in the activity history</label>
      <Btn v="primary" loading={busy} disabled={name.trim().length < 2 || name.trim() === target.name} onClick={save} data-testid="rename-save-button"><PenLine className="h-5 w-5" /> Save corrected name</Btn>
    </div>
  );
}
